export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4a2c72362623483600d74f59219662b8.jpg"
          alt="Professional welding contractor performing structural steel fabrication on commercial job site in Yuba County California"
          title="New Generation Welding - Licensed Welding Contractor"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-32 pb-20">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-0.5 bg-[#E8740C]"></div>
            <span className="text-[#E8740C] text-sm font-semibold tracking-[0.2em] font-heading uppercase">Licensed &amp; Insured Welding Contractor</span>
          </div>

          <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.05] mb-6">
            <span className="block">CONTRACTOR-GRADE</span>
            <span className="block text-[#E8740C]">WELDING &amp;</span>
            <span className="block">FABRICATION</span>
          </h1>

          <p className="text-white/80 text-base md:text-lg leading-relaxed mb-8 max-w-xl font-body">
            <strong>Structural steel welding</strong>, custom metal fabrication, heavy equipment repair &amp; mobile welding services trusted by general contractors across <strong>Northern &amp; Southern California</strong>.
          </p>

          <div className="flex flex-wrap gap-4 mb-12">
            <a
              href="#request-quote"
              onClick={(e) => { e.preventDefault(); scrollToSection('request-quote'); }}
              className="bg-[#E8740C] text-white font-heading font-bold text-sm tracking-wider px-8 py-4 rounded-md hover:bg-[#d16a0b] transition-all cursor-pointer whitespace-nowrap"
            >
              REQUEST A FREE QUOTE
            </a>
            <a
              href="tel:5308068659"
              className="border-2 border-white/40 text-white font-heading font-bold text-sm tracking-wider px-8 py-4 rounded-md hover:border-white hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-base"></i></div>
              530-806-8659
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-6 text-white/70 text-xs font-medium tracking-wider">
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-shield-check-fill text-[#E8740C] text-sm"></i></div>
              <span>24/7 EMERGENCY SERVICE</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-map-pin-fill text-[#E8740C] text-sm"></i></div>
              <span>MOBILE &amp; ON-SITE</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-price-tag-3-fill text-[#E8740C] text-sm"></i></div>
              <span>COMPETITIVE PRICING</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom stats bar */}
      <div className="absolute bottom-0 left-0 right-0 bg-[#1A1A1A]/90 backdrop-blur-sm border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="text-center">
            <p className="text-[#E8740C] font-heading font-bold text-2xl md:text-3xl">500+</p>
            <p className="text-white/60 text-xs tracking-wider mt-1">PROJECTS COMPLETED</p>
          </div>
          <div className="text-center">
            <p className="text-[#E8740C] font-heading font-bold text-2xl md:text-3xl">24/7</p>
            <p className="text-white/60 text-xs tracking-wider mt-1">EMERGENCY RESPONSE</p>
          </div>
          <div className="text-center">
            <p className="text-[#E8740C] font-heading font-bold text-2xl md:text-3xl">100%</p>
            <p className="text-white/60 text-xs tracking-wider mt-1">LICENSED &amp; INSURED</p>
          </div>
          <div className="text-center">
            <p className="text-[#E8740C] font-heading font-bold text-2xl md:text-3xl">NorCal</p>
            <p className="text-white/60 text-xs tracking-wider mt-1">&amp; SOCAL COVERAGE</p>
          </div>
        </div>
      </div>
    </section>
  );
}
